import { Private_Routes, Public_Routes } from '@common/url';
import { FROZEN_EMPTY_OBJECT } from '@prophecy/utils/constants';
import { useInterval } from '@prophecy/utils/react/hooks';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppMetadata } from '../../context/appMetadata';
import { getRecentUpdateInfo } from '../../context/getAppMetadata';
import { MaintainanceType } from '../../context/types';
import { useUser } from '../../context/user';
import { MaintenancePage } from '../Errors';
import { RESTORED, RESTORING, UPGRADED, UPGRADING } from './constants';

export default function Maintenance() {
  const updateInfo = useAppMetadata()?.maintenanceUpdateInfo || (FROZEN_EMPTY_OBJECT as MaintainanceType);
  const userId = useUser()?.user.id;
  const [remainingTime, setRemainingTime] = useState<number>(updateInfo?.estimatedTimeRemainingForUpgrade ?? 0);
  const upgradeStatus = updateInfo?.upgrade_status?.status;
  const navigate = useNavigate();
  const homeUrl = Private_Routes.Home.getUrl();
  const SignInURL = Public_Routes.SignIn.getUrlWithBasePath(undefined);
  useInterval(async () => {
    const updateInfo = await getRecentUpdateInfo();
    setRemainingTime(updateInfo?.estimatedTimeRemainingForUpgrade ?? 0);
  }, 30 * 1000);
  useEffect(() => {
    if ((upgradeStatus && (upgradeStatus === UPGRADED || upgradeStatus === RESTORED)) || remainingTime === 0) {
      if (userId) {
        navigate(homeUrl); // redirectToHome
      } else {
        navigate(SignInURL); // redirectToHome
      }
    }
  }, [upgradeStatus, navigate, remainingTime, homeUrl, userId, SignInURL]);

  let heading = '';
  let subheading = 'Under maintenance';
  let description = "Sorry, the page you are looking for doesn't exist or has been moved.";

  if (updateInfo?.upgrade_status) {
    if (updateInfo.upgrade_status.status === UPGRADING) {
      heading = 'We’ve got something special coming.';
      description = `Prophecy is undergoing a scheduled update, please check back in ${remainingTime} minutes.`;
    } else if (updateInfo.upgrade_status.status === RESTORING) {
      heading = 'Oops, the update failed.';
      description = `Prophecy has initiated a roll back due to an update failure, please check back in ${remainingTime} mins.`;
    }
  }

  return <MaintenancePage heading={heading} subheading={subheading} description={description} />;
}
